import PageErrorFallback from '@app/components/layout/page/components/page-error-fallback';
import { ObjectDetailContextType } from '@app/types';
import { ErrorBoundary } from '@sentry/react';
import { useGetIngredient } from '@shared/api/hooks/pcf/ingredients';
import { IngredientDetail } from '@shared/api/types';
import { useHistory } from '@shared/providers/history-provider';
import { createContext, useCallback, useContext, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

export interface IngredientDetailContextType
  extends ObjectDetailContextType<IngredientDetail> {}

const Context = createContext<IngredientDetailContextType | null>(null);

export function useIngredientDetailContext() {
  return useContext(Context) as IngredientDetailContextType;
}

export default function IngredientDetailContext() {
  const params = useParams();
  const history = useHistory();
  const [referrer] = useState<string | undefined>(history.previousLocation);

  const { data, status, refetch } = useGetIngredient(params.ingredient_uuid!);

  const refetchItem = useCallback(() => {
    return refetch();
  }, [refetch]);

  const context: IngredientDetailContextType = {
    item: data!,
    status,
    refetchItem,
    referrer,
  };

  return (
    <>
      <ErrorBoundary fallback={<PageErrorFallback />}>
        <Context.Provider value={context}>
          <Outlet />
        </Context.Provider>
      </ErrorBoundary>
    </>
  );
}
